import { SearchResults } from 'store/search/types';
import { createAction } from 'typesafe-actions';

export const doCloudPropertiesOpen = createAction('doCloudPropertiesOpen')();

export const doCloudPropertiesFilter = createAction('doCloudPropertiesFilter')<{
  search: string;
  sortId: 'relevant:asc' | 'name:asc' | 'name:desc';
  organisationIds: string[];
}>();

export const doCloudPropertiesSetLoadKey = createAction(
  'doCloudPropertiesSetLoadKey',
)<string>();

export const doCloudPropertiesSetData = createAction(
  'doCloudPropertiesSetData',
)<SearchResults>();

export const doCloudPropertiesClosed = createAction(
  'doCloudPropertiesClosed',
)();

export const doCloudPropertiesResetModal = createAction(
  'eventCloudPropertiesResetModal',
)();
